export enum TimeFormat {
  /**
   * 12h format (AM/PM)
   */
  TWELVE_HOUR_TIME_FORMAT = 'hh:mm A',

  /**
   * 24 hour format
   */
  MILITARY_TIME_FORMAT = 'HH:mm',
}
